var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2667 9.99982C17.4333 9.99982 18.3333 9.16649 17.5333 6.43316C16.9917 4.59149 15.4083 3.00816 13.5667 2.46649C10.8333 1.66649 10 2.56649 10 4.73316V7.13316C10 9.16649 10.8333 9.99982 12.5 9.99982H15.2667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6672 12.2501C15.8922 16.1085 12.1922 18.9085 7.98384 18.2251C4.82551 17.7168 2.28384 15.1751 1.76718 12.0168C1.09218 7.82513 3.87551 4.12513 7.71718 3.3418",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoAnalytics);
export default __webpack_public_path__ + "static/media/trvto_analytics.54d205cac71263b32ebee634983db96d.svg";
export { ForwardRef as ReactComponent };